'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withCarousel = require('../with-carousel');

var _ChangeSlideButton = require('./ChangeSlideButton');

var _ChangeSlideButton2 = _interopRequireDefault(_ChangeSlideButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangeSlideButton = function ChangeSlideButton(_ref) {
    var children = _ref.children,
        disabled = _ref.disabled,
        props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'disabled']);
    return _react2.default.createElement(
        _withCarousel.CarouselSubscriber,
        null,
        function (carousel) {
            return _react2.default.createElement(
                _ChangeSlideButton2.default,
                (0, _extends3.default)({}, props, {
                    disabled: disabled,
                    carousel: carousel
                }),
                children
            );
        }
    );
};
ChangeSlideButton.propTypes = {
    children: _propTypes2.default.node,
    disabled: _propTypes2.default.bool

};
ChangeSlideButton.defaultProps = {
    disabled: false,
    children: undefined
};

exports.default = ChangeSlideButton;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-carousel/lib/cjs/ChangeSlideButton/index.js
 ** module id = 585
 ** module chunks = 1
 **/